/* Avis Maison Dolce - couche interactive au-dessus des donnees Judge.me */
(function () {
  "use strict";

  var root = document.querySelector("[data-dr]");
  if (!root) return;

  var PAGE = 6;
  var list = root.querySelector("[data-dr-list]");
  var cards = list ? [].slice.call(list.querySelectorAll(".dr-card")) : [];
  var chips = [].slice.call(root.querySelectorAll(".dr-chip"));
  var rows = [].slice.call(root.querySelectorAll(".dr-histo__row"));
  var sortSel = root.querySelector("[data-dr-sort]");
  var moreBtn = root.querySelector("[data-dr-more]");
  var emptyEl = root.querySelector("[data-dr-empty]");

  var filter = "all";
  var shown = PAGE;

  function num(el, attr) {
    return parseFloat(el.getAttribute(attr)) || 0;
  }

  function matching() {
    if (filter === "all") return cards;
    return cards.filter(function (c) {
      return String(num(c, "data-rating")) === String(filter);
    });
  }

  function applySort() {
    if (!sortSel || !list) return;
    var mode = sortSel.value;
    var sorted = cards.slice().sort(function (a, b) {
      if (mode === "recent") return num(b, "data-ts") - num(a, "data-ts");
      if (mode === "old") return num(a, "data-ts") - num(b, "data-ts");
      if (mode === "high") return num(b, "data-rating") - num(a, "data-rating") || num(b, "data-ts") - num(a, "data-ts");
      return num(a, "data-rating") - num(b, "data-rating") || num(b, "data-ts") - num(a, "data-ts");
    });
    sorted.forEach(function (c) {
      list.appendChild(c);
    });
    cards = sorted;
  }

  function render() {
    var visible = matching();
    cards.forEach(function (c) {
      c.hidden = true;
    });
    visible.slice(0, shown).forEach(function (c, i) {
      c.hidden = false;
      c.style.animationDelay = i < PAGE ? i * 45 + "ms" : "0ms";
    });
    if (emptyEl) emptyEl.hidden = visible.length !== 0;
    if (moreBtn) {
      var rest = visible.length - shown;
      moreBtn.hidden = rest <= 0;
      moreBtn.textContent = rest > 0 ? "Voir " + rest + " avis de plus" : "Voir plus d'avis";
    }
  }

  function setFilter(val) {
    filter = String(val);
    shown = PAGE;
    chips.forEach(function (c) {
      c.classList.toggle("is-active", c.getAttribute("data-dr-filter") === filter);
    });
    rows.forEach(function (r) {
      r.classList.toggle("is-active", r.getAttribute("data-dr-filter") === filter);
    });
    render();
  }

  chips.concat(rows).forEach(function (el) {
    el.addEventListener("click", function () {
      if (el.disabled) return;
      var val = el.getAttribute("data-dr-filter");
      setFilter(val === filter && val !== "all" ? "all" : val);
    });
  });

  if (sortSel) {
    sortSel.addEventListener("change", function () {
      shown = PAGE;
      applySort();
      render();
    });
  }

  if (moreBtn) {
    moreBtn.addEventListener("click", function () {
      shown += PAGE;
      render();
    });
  }

  /* panneau "comment nous collectons les avis" */
  var trustBtn = root.querySelector(".dr-trust__btn");
  var trustPanel = root.querySelector(".dr-trust__panel");

  function openTrust(scroll) {
    if (!trustPanel || !trustBtn) return;
    trustPanel.hidden = false;
    trustBtn.setAttribute("aria-expanded", "true");
    if (scroll && trustPanel.scrollIntoView) {
      trustPanel.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  [].slice.call(root.querySelectorAll("[data-dr-howto]")).forEach(function (el) {
    el.addEventListener("click", function () {
      if (!trustPanel || !trustBtn) return;
      if (el === trustBtn) {
        var open = trustPanel.hidden;
        trustPanel.hidden = !open;
        trustBtn.setAttribute("aria-expanded", open ? "true" : "false");
      } else {
        openTrust(true);
      }
    });
  });

  /* compteur de la note moyenne */
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-dr-count")) || 0;
    if (!target) return;
    var start = null;
    var dur = 900;
    function step(ts) {
      if (start === null) start = ts;
      var k = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - k, 3);
      el.textContent = (target * eased).toFixed(2);
      if (k < 1) requestAnimationFrame(step);
      else el.textContent = String(target);
    }
    requestAnimationFrame(step);
  }

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function reveal() {
    if (root.classList.contains("is-in")) return;
    root.classList.add("is-in");
    var scoreEl = root.querySelector("[data-dr-count]");
    if (scoreEl && !reduce) countUp(scoreEl);
  }

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            reveal();
            io.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    io.observe(root);
    setTimeout(reveal, 2500);
  } else {
    reveal();
  }

  /* lightbox photos */
  var lb = document.getElementById("drLightbox");
  var lbImg = document.getElementById("drLightboxImg");
  if (lb && lbImg) {
    var closeLb = function () {
      lb.hidden = true;
      lbImg.removeAttribute("src");
      document.body.style.overflow = "";
    };
    root.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest("[data-dr-pic]") : null;
      if (!btn) return;
      lbImg.src = btn.getAttribute("data-dr-pic");
      lb.hidden = false;
      document.body.style.overflow = "hidden";
    });
    lb.addEventListener("click", function (e) {
      if (e.target === lb || (e.target.closest && e.target.closest(".dr-lightbox__close"))) closeLb();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !lb.hidden) closeLb();
    });
  }

  /* bouton ecrire un avis */
  [].slice.call(document.querySelectorAll("[data-dr-write]")).forEach(function (btn) {
    btn.addEventListener("click", function () {
      var jdgm = document.querySelector(".jdgm-write-rev-link");
      if (jdgm) {
        jdgm.click();
        return;
      }
      window.location.href = "/pages/contact?sujet=" + encodeURIComponent("Avis sur " + (btn.getAttribute("data-product") || ""));
    });
  });

  applySort();
  render();
})();
